import styled from 'styled-components'

export const Link = styled.a`
  color: ${({ theme }) => theme.color.darkGrey};
  font-weight: 600;
  text-decoration: underline;
`
export const Title = styled.h2`
  margin-bottom: 29px;
  color: ${({ theme }) => theme.color.darkGrey} !important;
`
export const ButtonWrapper = styled.div`
  margin: 40px auto 17px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
`
export const Body = styled.div`
  background-color: ${({ theme }) => theme.color.white};
  text-align: center;
  padding: 20px;
  padding-bottom: 50px;
  border-radius: 5px;

  svg {
    height: 170px;
    width: 280px;
    transition: 0.3s;
  }
`

export const Container = styled.div`
  position: fixed;
  z-index: 6;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: ${({ theme }) => theme.color.white};
  padding: 0px 16px 0px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  > div {
    width: 100%;
  }
`
